export default __webpack_public_path__ + "static/ico-city-04f0950812c1b25f33c6e99bed97e171.svg";